export default "__VITE_ASSET__063dda95__"